import React from 'react';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import { TextVariant, Typography } from '@components/shared/design/Typography';
import { ContentRelationshipFieldPrismic } from '@contracts';
import ContributorLinkNames from './components/ContributorLinkNames';

export interface Props {
  introText: string;
  contributors: ContentRelationshipFieldPrismic[];
}

export default function ArticleContributorType({ introText, contributors }: Props) {
  return (
    <ContributorStyled $variant={TextVariant.BodyRegularMD}>
      {introText} <ContributorLinkNames people={contributors} />
    </ContributorStyled>
  );
}

const ContributorStyled = styled(Typography)`
  &:not(:last-child) {
    margin-bottom: 16px;
  }

  & p {
    color: ${Colors.navyBlue};
  }
  & a {
    color: ${Colors.navyBlue};
    text-decoration: underline;
  }
`;
